import { View, ActivityIndicator, Pressable } from "react-native"
import { SafeAreaView } from "react-native-safe-area-context"
import { Link, useLocalSearchParams } from "expo-router"

import { Text, ScrollView, Header } from "@src/components"
import { trpc, priceFromDBFormat, formatDateForDisplay, sharedStyles } from "@src/utils"
import { ar } from "@src/i18n/ar"

export default function Receipt() {
  const params = useLocalSearchParams<{ hash: string }>()
  const receipt = trpc.shifts.getNewReceiptByHash.useQuery({ hash: params.hash })

  if (receipt.isLoading) {
    return (
      <>
        <Header title={ar.receiptDetails} />
        <ActivityIndicator className="mt-2" />
      </>
    )
  }

  if (!receipt.data) return null

  return (
    <>
      <Header title={`${ar.receiptNumber} #${receipt.data.number}`} />
      <ScrollView contentContainerStyle={sharedStyles.contentContainer} onRefresh={() => receipt.refetch()}>
        {/* Receipt Header Info */}
        <View className="bg-white p-4 rounded mb-4 shadow-sm">
          <View className="flex-row justify-between mb-3 pb-3 border-b border-gray-200">
            <Text className="text-gray-600">{ar.receiptNumber}</Text>
            <Text className="font-semibold">{receipt.data.number}</Text>
          </View>
          <View className="flex-row justify-between mb-3">
            <Text className="text-gray-600">{ar.date}</Text>
            <Text className="font-semibold">{formatDateForDisplay(receipt.data.time)}</Text>
          </View>
          <View className="flex-row justify-between mb-3">
            <Text className="text-gray-600">{ar.paymentMethod}</Text>
            <Text className="font-semibold capitalize">{receipt.data.paymentMethod}</Text>
          </View>
          {receipt.data.note && (
            <View className="flex-row justify-between pt-3 border-t border-gray-200">
              <Text className="text-gray-600">{ar.notes}</Text>
              <Text className="font-semibold flex-1 text-right">{receipt.data.note}</Text>
            </View>
          )}
        </View>

        {/* Items Table */}
        <View className="bg-white p-4 rounded mb-4 shadow-sm">
          <Text className="font-semibold text-gray-700 mb-3">{ar.items}</Text>
          {receipt.data.items.map((item) => (
            <Link href={`/dashboard/products/${item.productId}`} key={item.id} asChild>
              <Pressable className="py-2 active:opacity-70">
                <View className="flex-row justify-between mb-1">
                  <Text className="font-medium text-gray-900 flex-1 text-left">{item.name}</Text>
                  <Text className="font-semibold text-gray-900">{priceFromDBFormat(item.total)}</Text>
                </View>
                <View className="flex-row justify-between">
                  <Text className="text-gray-600 text-sm">
                    {item.quantity} × {priceFromDBFormat(item.price)}
                  </Text>
                </View>
              </Pressable>
            </Link>
          ))}
        </View>

        <View className="flex-row justify-between mb-2 py-2 border-t border-gray-300">
          <Text className="font-bold text-lg">{ar.total}</Text>
          <Text className="font-bold text-lg text-blue-600">{priceFromDBFormat(receipt.data.amount)}</Text>
        </View>
        <SafeAreaView edges={["bottom"]} />
      </ScrollView>
    </>
  )
}
